class SFrequentlyBoughtTogether extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const form = this.closest('form');

    this.querySelector('[data-fbt-accessory]')?.addEventListener('change', () => this.#update(), opts);
    // Quantity lives in the surrounding product form, so the total follows it.
    form?.addEventListener('input', () => this.#update(), opts);
    form?.addEventListener('change', () => this.#update(), opts);
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #quantity() {
    const input = this.closest('form')?.elements.namedItem('quantity');
    const value = Number.parseInt(input?.value || '1', 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  #update() {
    const checkbox = this.querySelector('[data-fbt-accessory]');
    const withAccessory = Boolean(checkbox?.checked);
    const mainPrice = Number(this.dataset.mainPrice || 0);
    const accessoryPrice = Number(this.dataset.accessoryPrice || 0);
    const total = mainPrice * this.#quantity() + (withAccessory ? accessoryPrice : 0);

    const output = this.querySelector('[data-fbt-total] bdi');
    if (output) output.textContent = this.#formatMoney(total);

    const label = this.querySelector('[data-fbt-label]');
    if (label) label.textContent = withAccessory ? this.dataset.labelBoth : this.dataset.labelOne;
  }

  #formatMoney(cents) {
    const format = this.dataset.moneyFormat || '${{amount}}';
    const value = cents / 100;
    const withDelimiters = (amount, decimals, thousands, decimal) => {
      const [whole, fraction] = amount.toFixed(decimals).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? `${grouped}${decimal}${fraction}` : grouped;
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return withDelimiters(value, 2, "'", '.');
        default:
          return withDelimiters(value, 2, ',', '.');
      }
    });
  }
}

if (!customElements.get('s-frequently-bought-together')) {
  customElements.define('s-frequently-bought-together', SFrequentlyBoughtTogether);
}
